<template>
  <div class="scan-goods">
    <div class="shoppingCart">
	  <div class="list" v-if="cartList.length > 0">
		<div class="item acea-row row-between-wrapper" v-for="(item,index) in cartList" :key="index">
		  <div class="picTxt acea-row row-between-wrapper">
			<div class="pictrue">
			  <img :src="item.productInfo.image" />
			</div>
			<div class="text">
			  <div class="line1">{{ item.productInfo.store_name }}</div>
			  <div class="infor line1">
				<p>属性：{{ item.productInfo.attrInfo.suk }}</p>
			  </div>
			  <div class="money">￥{{ item.productInfo.attrInfo.price }}</div>
			</div>
			<div class="scan-del iconfont icon-shanchu" @click.prevent="delGoods(index)"> 删除</div>
			<div class="carnum acea-row row-center-wrapper">
			  <div
				class="reduce"
				@click.prevent="reduce(index)"
			  >
				-
			  </div>
			  <div class="num">
				<input
				  type="number"
				  class="ipt_num"
				  v-model="item.cart_num"
				  @input.prevent="specifiName(index)"
				  @blur.prevent="blurName(index)"
				/>
			  </div>
			  <div
				class="plus"
				@click.prevent="plus(index)"
			  >
				+
			  </div>
			</div>
		  </div>
		</div>
		
	  </div>
	  <div v-else class="noCart">
		  <div class="pictrue"><img src="@assets/images/noCart.png" /></div>
	  </div>
	  <!-- 选择版本 -->
	  <div class="mask" v-if="isMsak">
		  <div class="choose-goods-wapper" v-if="chooseList.length > 0">
			  <div class="choose-title">{{ msg }}</div>
			  <ul class="choose-list">
				  <li v-for="(item,index) in chooseList" :key="index">
					  <div class="suk" @click.prevent="postCartAdd(item.unique)">{{ item.suk }}</div>
				  </li>
			  </ul>
		  </div>
	  </div>
	</div>
	<div class="footer-wapper">
		<div class="total">合计：<strong><i>¥</i>{{ countmoney }}</strong></div>
		<div class="flex-btn">
			<div class="btn-settlement" v-if="cartList.length > 0" @click="postCartDeity()">挂单</div>
			<div class="btn-settlement" @click="$router.replace('/user/cart_point')">取单</div>
			<div class="btn-settlement" @click="continueScan()">继续扫码</div>
			<div
			  class="btn-settlement"
			  v-if="cartList.length > 0"
			  @click="settlement()"
			>
				立即提交
			</div>
		</div>
	</div>
  </div>
</template>

<script>

import { wechatEvevt } from "@libs/wechat";
import debounce from "lodash.debounce";
import { changeCartNum, postCartDel } from "@api/store";
import { cashierCartList, cashierCartAdd, cartDeity } from "@api/order";
const NAME = "ScanGoods";

export default {
  name: NAME,
  
  props: {},
  data: function() {
    return {
	  uid: 0,
      iswechat: this.$wechat.isWeixin(),
      verify_code: "",
	  countmoney: "",
	  msg: "",
	  cartList: [],
	  chooseList: [],
	  isMsak: false,//选择版本的遮罩层
	  isScan: true
    };
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
		let that = this;
		if(oldVal === "CartPoint"){
			that.isScan = false;
		}
		that.postCartList();
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
	this.postCartList();
	if(!this.$route.query.cartpoint) this.openQRCode();
  },
  methods: {
	postCartList(){
		let that = this;
		that.$dialog.loading.open("加载中");
		if(that.$route.query.uid){
			that.uid = that.$route.query.uid;
		}
		cashierCartList(that.uid).then(res => {
			that.$dialog.loading.close();
			that.uid = res.data.uid;
			that.cartList = res.data.info;
			that.countMoney();
		}).catch(err => {
			that.$dialog.loading.close();
			that.$dialog.error(err.msg);
			that.$router.go(0);
		});
	},
	postCartAdd(unique){
		let that = this;
		if (!that.verify_code) return this.$dialog.error("请扫码");
		that.$dialog.loading.open("加载中");
		let addData = {
			code: that.verify_code,
			uid: that.uid,
			unique: unique
		}
		cashierCartAdd(addData).then(res => {
			that.$dialog.loading.close();
			that.uid = res.data.uid;
			that.isScan = true;
			if(res.data.status == 0){
				that.cartList = res.data.info;
			}
			// 不同版本同一个码，选择版本
			if(res.data.status == 3){
				that.isMsak = true;
				that.chooseList = res.data.info;
				that.msg = res.data.msg;
			}
			that.countMoney();
			setTimeout(function(){
				that.openQRCode();
			},1000);
		}).catch(err => {
			that.$dialog.loading.close();
			that.verify_code = "";
			that.$dialog.error(err.msg);
			that.isScan = true;
			setTimeout(function(){
				that.openQRCode();
			},1000);
		});
	},
    openQRCode: function() {
	  // this.postCartAdd();//本地执行
      let that = this;
	  if(!that.isScan) return false;
	  that.isScan = false;
      wechatEvevt("scanQRCode", {
        needResult: 1,// 默认为0，扫描结果由微信处理，1则直接返回扫描结果
        onlyFromCamera: false,
        scanType: ["barCode"]// 可以指定扫二维码还是一维码，默认二者都有
      })
        .then(res => {
          if (res.resultStr) {
			var resultData = res.resultStr.split(',');
            that.verify_code = resultData[1];
            that.postCartAdd();
          } else that.$dialog.error("没有扫描到什么！");
        })
        .catch(res => {
          console.log(res);
          if (res.is_ready) {
            res.wx.scanQRCode({
              needResult: 1,
              onlyFromCamera: false,
              scanType: ["barCode"],
              success: function(res) {
				var resultData = res.resultStr.split(',');
                that.verify_code = resultData[1];
                that.postCartAdd();
              },
              fail: function(res) {
                console.log(res);
                if (res.errMsg == "scanQRCode:permission denied") {
                  that.$dialog.error("没有权限");
                }
              }
            });
          }
        });
    },
	//继续扫码
	continueScan(){
		let that = this;
		that.isScan = true;
		that.$dialog.toast({mes: that.isScan + "即将扫码请稍后…"});
		that.openQRCode();
	},
	//加
	plus: function(index) {
	  let that = this;
	  let list = that.cartList[index];
	  list.cart_num++;
	  if (list.productInfo.attrInfo) {
	    if (list.cart_num >= list.productInfo.attrInfo.stock) {
		  that.$dialog.toast({mes:'商品不能再增加了'});
	      that.$set(list, "cart_num", list.productInfo.attrInfo.stock);
	    }
	  } else {
	    if (list.cart_num >= list.productInfo.stock) {
		  that.$dialog.toast({mes:'商品不能再增加了'});
	      that.$set(list, "cart_num", list.productInfo.stock);
	    }
	  }
	  that.countMoney();
	  that.syncCartNum(list);
	},
	specifiName(index) {
	  let list = this.cartList[index];
	  this.countMoney();
	  this.syncCartNum(list);
	},
	blurName(index) {
	  let that = this;
	  let list = that.cartList[index];
	  if (list.cart_num < 1) {
		that.$dialog.toast({mes:'商品数量不能是0哦'});
	    that.$set(list, "cart_num", 1);
	  }
	  if (list.productInfo.attrInfo) {
	    if (list.cart_num >= list.productInfo.attrInfo.stock) {
		  that.$dialog.toast({mes:'超出数量范围'});
	      that.$set(list, "cart_num", list.productInfo.attrInfo.stock);
	    }
	  } else {
	    if (list.cart_num >= list.productInfo.stock) {
		  that.$dialog.toast({mes:'超出数量范围'});
	      that.$set(list, "cart_num", list.productInfo.stock);
	    }
	  }
	  that.countMoney();
	  that.syncCartNum(list);
	},
	//减
	reduce: function(index) {
	  let that = this;
	  let list = that.cartList[index];
	  list.cart_num--;
	  if (list.cart_num < 1) {
		that.$dialog.toast({mes:'商品不能再减少了'});
	    that.$set(list, "cart_num", 1);
	  }
	  that.countMoney();
	  that.syncCartNum(list);
	},
	syncCartNum(cart) {
	  let that = this;
	  if (!cart.sync)
	    cart.sync = debounce(() => {
	      changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1, that.uid)
	    }, 500);
	  cart.sync();
	},
	//总价；
	countMoney: function() {
	  let that = this;
	  let carmoney = 0;
	  let array = that.cartList;
	  for (let i = 0; i < array.length; i++) {
		  let num = parseInt(array[i].cart_num);
		  let price = parseFloat(array[i].productInfo.attrInfo.price).toFixed(2);
		  carmoney += num * price;
	  }
	  that.countmoney = parseFloat(carmoney).toFixed(2);
	},
	//删除
	delGoods(index){
		let that = this,
		  cart = that.cartList[index],
		  id = [];
		id.push(cart.id);
		that.$dialog.confirm({
		  mes: "是否删除该商品",
		  opts: [
			{
			  txt: "取消",
			  color: false
			},
		    {
		      txt: "删除",
		      color: true,
		      callback: () => {
		        postCartDel(id, that.uid).then(function() {
		          that.cartList.splice(index, 1);
		          that.countMoney();
		          that.$dialog.success('删除成功');
		        }).catch(err => {
		          that.$dialog.error(err.msg);
		        });
		      }
		    }
		  ]
		});
	},
	// 挂单
	postCartDeity(){
		let that = this,
		  data = {
			  uid: that.uid
		  };
		cartDeity(data).then(res => {
			that.$dialog.success('挂单成功');
			that.cartList = [];
			that.countMoney();
			that.uid = 0;
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	//结算
	settlement(){
		let that = this,
		  cartidarr = [];
		for (var i=0; i<that.cartList.length; i++){
			cartidarr.push(that.cartList[i].id)
		}
		let cartid = cartidarr.join(',');
		that.$router.push('/user/order_submit/' + that.uid + '/' + cartid);
	}
  }
};
</script>
<style scoped>
.shoppingCart .list{
	margin-top: 0;
	margin-bottom: 1.2rem;
}
.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.44rem;
  text-align: center;
}
.scan-del{
	position: absolute;
	top: 0;
	right: -0.7rem;
	font-size: 0.28rem;
	color: red;
}
.shoppingCart .list .item .picTxt .text .money{
	margin-top: 0.16rem;
}
.shoppingCart .list .item .picTxt .carnum{
	right: -0.7rem;
	bottom: 0;
}
.noCart{
	background: none;
	text-align: center;
	color: #666;
}
.mask{
	display: flex;
	justify-content: center;
	align-items: center;
}
.choose-title{
	text-align: center;
	height: 1rem;
	line-height: 1rem;
	border-bottom: 1px solid #eee;
	font-size: 0.32rem;
	font-weight: bold;
}
.choose-goods-wapper{
	width: 6rem;
	background-color: #fff;
}
.choose-list{
	padding: 0 0.3rem;
}
.choose-list li{
	border-bottom: 1px solid #eee;
	padding: 0.3rem 0.1rem;
}
.choose-list li:last-child{
	border-bottom: none;
}
.footer-wapper{
	width: 100%;
	position: fixed;
	left: 0;
	bottom: 0;
	background-color: #fff;
	box-shadow: 0 0 5px 0 #eee;
}
.footer-wapper .total{
	text-align: right;
	padding: 0.2rem;
	border-bottom: 1px solid #eee;
}
.footer-wapper .total strong{
	color: #F21B07;
	font-size: 0.32rem;
}
.footer-wapper .total strong i{
	font-size: 0.26rem;
	margin-right: 0.05rem;
}
.flex-btn{
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0.2rem 0;
}
.btn-settlement{
	color: #fff;
	background-color: #e93323;
	border-radius: 0.5rem;
	margin-right: 0.2rem;
	padding: 0.1rem 0.3rem;
}
</style>